/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { CTAImage } from "cms/components/components/call-to-action/display/image";
import { CTALink } from "cms/components/components/call-to-action/display/link";
import { isArrayNotEmpty, isStringNotEmpty, isRichTextNotEmpty } from "utils/empty-exists";

const CTAHorizontal = (props) => {
    const {
        image,
        title,
        description,
        links,
        style,
        format,
    } = props;
    
    return (
        <div className={"simplicity-cta-container horizontal"}>
            {image &&
                <CTAImage
                    image={image}
                    imageCard='horizontal'
                />
            }
            
            <div className={"simplicity-cta-content horizontal"}>
                {isStringNotEmpty(title) &&
                    <div className='simplicity-cta-title'>{title}</div>
                }
                {isRichTextNotEmpty(description) &&
                    <RichTextPreview richtext={description} />
                }
                {isArrayNotEmpty(links) &&
                    links.map((link, idx) => (
                        <div
                            className='simplicity-cta-link'
                            key={idx}
                        >
                            <CTALink
                                idx={idx}
                                link={link}
                                style={style}
                                format={format}
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    );
};
CTAHorizontal.displayName = "CTAHorizontal";
export { CTAHorizontal };
